import request from '../../../../util/APIUtils';
import { PORTAL_API_BASE_URL } from '../../../../constants';

export const MAX_REENTRY_PLANS_PAGE_SIZE = 100;

const buildReentryPlansQuery = ({
  locationIds,
  page,
  pageSize,
  planTypes,
  scope,
  sortBy,
  sortOrder,
  filters,
} = {}) => {
  const params = new URLSearchParams();

  if (locationIds != null && locationIds !== '') {
    params.append('locationIds', String(locationIds));
  }
  if (Array.isArray(planTypes) && planTypes.length > 0) {
    params.append('planTypes', planTypes.join(','));
  }
  // Omitted scope lets the API apply its own default (all plans in the facility scope).
  if (scope) {
    params.append('scope', scope);
  }
  if (page != null) {
    params.append('page', page);
  }
  if (pageSize != null) {
    params.append('pageSize', Math.min(Number(pageSize), MAX_REENTRY_PLANS_PAGE_SIZE));
  }
  if (sortBy) {
    params.append('sortBy', sortBy);
  }
  if (sortOrder) {
    params.append('sortOrder', sortOrder);
  }
  if (filters && typeof filters === 'object') {
    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value != null && value !== '') {
        params.append(key, String(value));
      }
    });
  }

  const query = params.toString() ? `?${params.toString()}` : '';
  return query;
};

export const fetchReentryPlans = ({
  locationIds,
  page = 1,
  pageSize = 25,
  planTypes,
  scope,
  sortBy,
  sortOrder,
  filters,
} = {}) => {
  const query = buildReentryPlansQuery({
    locationIds,
    page,
    pageSize,
    planTypes,
    scope,
    sortBy,
    sortOrder,
    filters,
  });

  return request({
    url: `${PORTAL_API_BASE_URL}/api/admin/case-plans${query}`,
    method: 'GET',
  });
};
